import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthHttpClient } from '../../../../providers/auth-http.service';
import { default as swal } from 'sweetalert2';


export class SharedInterviewService {
	private readonly baseUrlV3 = 'v3/interview/auth/client';

	constructor(private sHttp: AuthHttpClient) {}

	public getApplicationStages(params: any): Observable<any[]> {
		const url = `/${this.baseUrlV3}/application_stages`;
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	private extractData(res: Response) {
		if (res) {
			let resp: any = res;
			if (res.status === 401) {
				window.location.assign(process.env.LANDING_PAGES_URL);
			}
			if (resp._body && resp._body !== '') {
				return res.json();
			}
			return {};
		}
	}

	private handleError(error: any) {
		let errMsg = (error.message) ? error.message :
			error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		console.error(errMsg);
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		return Observable.throw(errMsg);
	}
static ctorParameters() { return [ { type: AuthHttpClient } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/services/shared-interview.service.ts